import React, { useRef, useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Button, Alert } from "react-bootstrap";
import { useForm, ValidationError } from "@formspree/react";
import { useTranslation } from "react-i18next";
import "../Style/ContactUs.css";

const ContactUs = () => {
  const { t } = useTranslation();
  const [state, handleSubmit] = useForm("mandnzye"); // your Formspree ID
  const [showSuccess, setShowSuccess] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    if (state.succeeded) {
      formRef.current?.reset();
      setShowSuccess(true);
      const tId = setTimeout(() => setShowSuccess(false), 4000);
      return () => clearTimeout(tId);
    }
  }, [state.succeeded]);

  return (
    <section id="contact" className="py-5 Contact-us" style={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <h2 className="text-center mb-4">{t("Contact Us")}</h2>
        <p className="text-center text-muted mb-5">
          {t("Have questions about our stamps? Reach out to us and we’ll get back to you as soon as possible.")}
        </p>
        <Row>
          {/* Contact Form */}
          <Col md={7}>
            <Card className="p-4 border-0" style={{ backgroundColor: "#fff" }}>
              <h5 className="mb-4">{t("Send us a message")}</h5>

              {showSuccess && (
                <Alert variant="success" className="mb-4">
                  ✅ {t("Thank you! Your message has been sent successfully.")}
                </Alert>
              )}

              <Form ref={formRef} onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Label className="paragraph">{t("Your Name")}</Form.Label>
                  <Form.Control type="text" name="name" placeholder={t("Enter your name")} required />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label className="paragraph">{t("Email address")}</Form.Label>
                  <Form.Control type="email" name="email" placeholder={t("Enter your email")} required />
                  <ValidationError prefix="Email" field="email" errors={state.errors} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPhone">
                  <Form.Label className="paragraph">{t("Phone Number")}</Form.Label>
                  <Form.Control type="text" name="phone" placeholder={t("Enter your phone number")} required />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formMessage">
                  <Form.Label className="paragraph">{t("Message")}</Form.Label>
                  <Form.Control as="textarea" rows={4} name="message" placeholder={t("Write your message here...")} required />
                  <ValidationError prefix="Message" field="message" errors={state.errors} />
                </Form.Group>

                <Button variant="light" type="submit" className="px-4 submitbtn" disabled={state.submitting}>
                  {state.submitting ? t("Sending...") : t("Send Message")}
                </Button>
              </Form>
            </Card>
          </Col>

          {/* Contact Info */}
          <Col md={5} className="mt-4 mt-md-0">
            <Card className="p-4 border-0" style={{ backgroundColor: "#fff" }}>
              <h5 className="mb-3">{t("Get in touch")}</h5>
              <p className="mb-2"><strong>{t("Address")}:</strong> Al - Sheikh Zayed Bin Sultan St - Hadbat Al Za`Faranah - E26 - Abu Dhabi - United Arab Emirates</p>
              <p className="mb-2"><strong>{t("Phone")}:</strong> +971559139165</p>
              <p className="mb-2"><strong>{t("Email")}:</strong> falconstarstamps@gmail.com</p>
              <p className="text-muted mt-3">{t("We are available Monday to Saturday, 9:00 AM – 6:00 PM.")}</p>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactUs;
